import { Button } from '@synoptic/ui-kit/button/button.js';
import { TrashIcon } from '@synoptic/ui-kit/icons/react/trash.js';
import {
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { ModalRoot } from '@synoptic/ui-kit/modal/modal.js';
import React, { PropsWithChildren, ReactNode } from 'react';
import { confirmModalActions } from './confirm-modal.css';

interface ConfirmModalProps {
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSuccess?: () => void;
  onCancel?: () => void;
  title: string;
  description: ReactNode;
  loading?: boolean;
  submitButton?: React.ReactNode;
}

export const ConfirmModal = ({
  isOpen,
  onOpenChange,
  onSuccess,
  onCancel,
  title,
  description,
  loading,
  children,
  submitButton,
}: PropsWithChildren<ConfirmModalProps>) => {
  return (
    <ModalRoot open={isOpen} onOpenChange={onOpenChange}>
      {children && <ModalTrigger asChild>{children}</ModalTrigger>}
      <ModalContent
        onPointerDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        {description}
        <div className={confirmModalActions}>
          <Button
            variant="secondary"
            onClick={() => {
              onCancel?.();
              onOpenChange?.(false);
            }}
          >
            Cancel
          </Button>

          {submitButton || (
            <Button
              startIcon={<TrashIcon />}
              loading={loading}
              onClick={onSuccess}
              variant="critical"
            >
              Delete
            </Button>
          )}
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
